/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import Modal from 'react-modal'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import '../../assets/styles/components/annoucements/CampaignPage.scss'

class SimplePreviewModal extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  createMarkup = () => ({ __html: this.props.announcement.message })

  render() {
    const { t } = this.props
    const date = moment(this.props.announcement.created_at).format('MM-DD-YYYY')

    return (
      <Modal
        isOpen={this.props.showModal}
        onRequestClose={() => this.props.closeModal()}
        contentLabel={t('announcements.common.modalContentLabel')}
      >
        <div className='modal-header row m-0 p-0'>
          <div className='col-11 m-0 p-0'>
            <h5 className='modal-title display-4'>
              {this.props.announcement.subject !== ''
                ? t('announcements.simplePreviewModal.titleEmail', { date })
                : t('announcements.simplePreviewModal.titleAnnouncement', { date })}
            </h5>
          </div>
          <div className='col-1 m-0 p-0'>
            <button
              type='button'
              className='close pull-right font-200'
              data-dismiss='modal'
              aria-label={t('common.close')}
              onClick={() => this.props.closeModal()}
            >
              <span aria-hidden='true'>✕</span>
            </button>
          </div>
        </div>
        <div className='container'>
          <div className='row mt-4'>
            <div className='col-md-12'>
              {this.props.announcement.subject !== '' ? (
                <div>
                  <h3>{t('announcements.simplePreviewModal.subject')}</h3>
                  <p className='border p-3'>
                    {this.props.announcement.subject}
                  </p>
                  <h3>{t('announcements.simplePreviewModal.message')}</h3>
                  <div
                    className='border p-3'
                    dangerouslySetInnerHTML={this.createMarkup()}
                  />
                </div>
              ) : (
                <div>
                  <h3>{t('announcements.simplePreviewModal.message')}</h3>
                  <p className='border p-3'>
                    {this.props.announcement.message}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

export default withTranslation()(SimplePreviewModal)
